import React, { useState } from 'react';
import { useEffect } from 'react';
import './CompanyInformation.css';
import Header from '../header/Header';
import MenuCompany from '../menu/MenuCompany';
import red_line from '../../img/red_line.png';
import { CompanyForm } from './companyForm/CompanyForm';
import { MobileMenuCompany } from '../mobileMenu/MobileMenuCompany';
import { FooterButtons } from '../common/buttons/FooterButtons';
import '../pageSize/PageSize.css';


export const CompanyInformation = () => {

    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(window.location.pathname);

  useEffect(() => {
    const handleWindowResize = () => {
        setIsMobile(window.matchMedia("(max-width: 767px)").matches);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
        window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
      function handlePageChange() {
          setCurrentPage(window.location.pathname);
      }
      window.addEventListener("popstate", handlePageChange);
      return () => {
          window.removeEventListener("popstate", handlePageChange);
      };
    }, [currentPage]);

  return (
    <div className='page-size'>
      <Header/>
      {isMobile ? <MobileMenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <MenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}
    <div className='company-information-container'>
      <div className='company-information-title'>
      <img style={{marginLeft: "0px"}} src={red_line} className='red-line'/>
        <p className='company-information-text'>Dane firmy</p>
      </div>
      <p style={{fontFamily:'Montserrat', marginTop:'5px'}}>Na poniższe dane zostanie wystawiona faktura</p>  
    <CompanyForm/>
    </div>
    </div>
    
   
  )
}
